import requestStatus from "./requestStatus"

// Main keys
export const ROUTER = 'router'
export const AUTH = 'auth'
export const LOAD_ALL ="loadAll"
export const CLI = 'cliData'
export const PROGRAM = 'programData'
export const WPSERVER = 'wpServerData'
export const WPLOCAL = 'wpLocalData'
export const UI = 'ui'
export const SIGNAGE_DATA = 'signageData'
export const PRINTDATA = 'printData'
export const PUSHDATA = 'pushData'
export const WEEK_PROGRAM_PRINTDATA = 'printData'
export const NEWSLETTERSERVER = 'newsletterServerData'
export const NEWSLETTERLOCAL = 'newsletterLocalData'
export const TRANSLATION = 'translation'
export const MULTISITE_SELECTOR = 'multisiteSelectorData'
export const ROUTES_DATA = 'routesData'
export const EVENT_DATA = 'eventData'

export const FLYER_DATA_DEFAULT = {
    headlineElements: {
        order:[],
        items: {}
    },
    textElements: {
        order:[],
        items: {}
    },
    imageElements: {
        order:[],
        items: {}
    },
    metroElements: {
        order:[],
        items: {}
    },
    flyers: null
}

export const WEEKPROGRAMFLYER_DEFAULT = {
    weekProgramFlyerSettings: {
        titleTopText: null,
        titleBottomText: null
    },
    customPeriodActive: false,
    hasChanges: false,
    dateSettings: {
        order:[],
        items: {}
    },
    choosenMovies: {
        order:[],
        items: {}
    }
}

export const NEWSPAPER_DEFAULT = {
    dateSettings: null,
    newspaperAnnouncementSettings: {
        logo: null,
        background: null,
        color: null,
        textInTopPart: null,
        showQRCode: null,
        hideUrlInTopPart: null
    },
    hasChanges: false,
    choosenMovies: {
        order:[],
        items: {}
    },
    bottomItems: {
        order:[],
        items: {}
    },
    customItems: {
        items: {}
    }
}

export const PROGRAM_DEFAULT = {
    status: requestStatus.INITIALIZED,
    error: {},
    hasUpdates: false,
    updates: {
        hasUpdates: false,
        lastUpdateIn: []
    },
    cinemas: {
        items: {},
    },
    metaMovies: {
        items: {},
        order: []
    },
    pyMovies: {
        items: {},
    },
    dieselv2Movies: {
        items: {},
    },
    cortecMovies: {
        items: {},
    },
    compesoMovies: {
        items: {},
    },
    khMovies: {
        items: {},
    },
    pmMovies: {
        items: {},
    },
    cliMovies: {
        items: {},
        order: []
    },
    performances: {
        items: {},
    },
    movieMappings: {
        items: {}
    },    
    attributes: {
        global: {
            genres: {},
            technical: {},
            fsk: {},
            theatres: {}
        }
    },
    elbenwaldBrandMappings : {
        items: {}
    },
    elbenwaldBrands: {
        items: {}
    },
    itemSelectionsDisplay: {
        items: {},
        order: []
    },
    movieExtensions: {
        items: {},
        itemsToReset: []
    },
    itemSelections: {
        items: {}
    },
    itemCollections: {
        items: {}
    },
    ads: {
        items: {}
    },
    advertisements: {
        items: {},
        order: []
    },
    highlights: {
        items: {}
    },
    weischerAds: {
        items: {}
    }
}

export const PROGRAM_UPDATE_DEFAULT = {
    pmMovies: {
        update: []
    },
    metaMovies: {
        update: []
    },
    movieExtensions: {
        update: []
    },
    itemSelectionsDisplay: {
        update: [],
        delete: []       
    },
    itemSelections: {
        update: [],
        delete: []
    },
    itemCollections: {
        update: [],
        delete: []
    },
    ads: {
        update: [],
        delete: []
    },
    highlights: {
        update: [],
        delete: []
    },
    weischerAds: {
        update: [],
        delete: []
    },
    advertisements: {
        update: [],
        delete: []
    },
    brandMovieMappingActions: {
        update: [],
        delete: []
    }
}

export const FLYER_DEFAULT = {
    pk: null,
    flyerSettings: {
        name: null,
        flyerBackground: null,
        flyerTextColor: null,
        logo: null,
        titleTopText: null,
        titleBottomText: null
    },
    gridImages: {
        order: [],
        items: {}
    },
    moviePerformances: {
        order: [],
        items: {}
    },
    dateSettings: null,
    flyerStructure: {
        inside: {
            left: {
                tooHigh: false,
                edited: false,
                order:[],
                items: {}
            },
            middle: {
                tooHigh: false,
                edited: false,
                order:[],
                items: {}
            },
            right: {
                tooHigh: false,
                edited: false,
                order:[],
                items: {}
            }
        },
        outside: {
            left: {
                tooHigh: false,
                edited: false,
                order:[],
                items: {}
            },
            middle: {
                tooHigh: false,
                edited: false,
                order:[],
                items: {}
            },
            right: {
                tooHigh: false,
                edited: false,
                grid: {
                    order:[],
                    items: {}
                },
                content: {
                    order:[],
                    items: {}
                }
            }
        }
    }
}

export const AD_DEFAULT = {
    pk: null,
    title: null,
    text: null,
    link: null,
    displayDateStart: null,
    displayDateEnd: null,
    cinema: null,
    movieRefID: null,
    imagePoster: null,
    position: 0,
    positionX: 0,
    positionY: 0,
    draft: true,
    cinemasFilter: null,
    showInApp: true
}

export const ADVERTISEMENT_DEFAULT = {
    pk: null,
    draft: true,
    type: null,
    title: null,
    link: null,
    displayDateStart: null,
    displayDateEnd: null,
    images: {},
    cinema: null,
    cinemasFilter: null,
    active: true,
    showInApp: false
}

export const HIGHLIGHT_DEFAULT = {
    title: null,
    text: null,
    movieRefID: null,
    cinema: null ,
    draft: true,
    cinemasFilter: null,
    showInApp: true
}

export const WEISCHERAD_DEFAULT = {
    payload: null,
    cinema: null,
    draft: true,
    cinemasFilter: null,
    active: false,
    fallbackLink: null,
    fallbackImage: null,
    type: null //main, overview, preroll, interscroller,  overview_main
}

export const FLYER_ELEMENT_DEFAULT = {
    payload: null,
    id: null
}

export const SELECTION_ELEMENT_DEFAULT = {
    title: null,
    type: null,
    filterType: null,
    filterValue: null,
    expireDate: null,
    cinema: null,
    showInApp: true,
    style: "Classic",
    trailerAutoplay: false,
    cinemasFilter: null
}

export const FLYER_ELEMENT_IMAGE_DEFAULT = {
    payload: null,
    id: null,
    width: null,
    height: null,
    position_y: 'center',
    position_x: 'center'
}

export const METRO_ELEMENT_DEFAULT = {
    id: null,
    title: null,
    description: null,
    date: null,
    image: null,
    position_y: 'center',
    position_x: 'center'
}

export const CUSTOM_ELEMENT_DEFAULT = {
    id: null,
    name: null,
    logo: null,
    movieId: null,
    style: 'withPerformances',
    newspaperBackground: null,
    newspaperTextColor: null
}

export const GRID_IMAGE_DEFAULT = {
    id: null,
    itemId: null,
    itemType: null,
    style: 'front',
    text: null,
    position: null
}

export const MOVIE_PERFORMANCE_DEFAULT = {
    id: null,
    movieId: null,
    style: 'extended',
    description: 'short'
}

export const NEWSLETTER_ELEMENT_TEXT_DEFAULT = {
    id: null,
    text: null 
}

export const NEWSLETTER_ELEMENT_IMAGE_DEFAULT = {
    id: null,
    img: null 
}

export const PUSH_DEFAULT = {
    title: null,
    body: null,
    cinemas: true,
    imageUrl: null,
    iconUrl: null,
    moviePk: null,
    published: true,
    mode: "Default"
}

export const PM_MOVIES_EDITABLE_KEYS = [
    "title",
    "titleDisplay",
    "subTitle",
    "description",
    "descriptionShort",
    "genres",
    "technologyAttributes",
    "showCountdown",
    "technical",
    "posterAttribute",
    "images",
    "displayDates",
    "trailerURL"
]

export const META_MOVIE_ORIGIN_KEYS = [
    "title",
    "description_short",
    "description",
    "genres",
    "trailerURL"
]

export const AUTH_STATUS = 'authStatus'
export const AUTH_ERROR = 'authError'
export const AUTH_CAPS = 'authCaps'

export const LOAD_ALL_STATUS =  'loadAllStatus'
export const LOAD_ALL_LOADED = 'loadAllLoaded'
export const LOAD_ALL_ERROR = 'loadAllError'


export const PROGRAM_STATUS = 'status'
export const PROGRAM_ERROR = 'error'

export const PROGRAM_CINEMAS = 'cinemas'

export const PROGRAM_CLI_MOVIES_ITEMS = 'cliMoviesItems'
export const PROGRAM_CLI_MOVIES_ORDER = 'cliMoviesOrder'

export const PROGRAM_PY_MOVIES_ITEMS = 'pyMoviesItems'
export const PROGRAM_KH_MOVIES_ITEMS = 'khMoviesItems'
export const PROGRAM_COMP_MOVIES_ITEMS = 'compMoviesItems'
export const PROGRAM_PM_MOVIES_ITEMS = 'pmMoviesItems'
export const PROGRAM_DIESEL_MOVIES_ITEMS = 'dieselMoviesItems'
export const PROGRAM_CORTEC_MOVIES_ITEMS = 'cortecMoviesItems'
export const PROGRAM_META_MOVIES_ITEMS = 'metaMoviesItems'

export const PROGRAM_SELECTIONSDISPLAY_ITEMS = 'selectionDisplayItems'
export const PROGRAM_SELECTIONSDISPLAY_ORDER = 'selectionDisplayOrder'

export const PROGRAM_SELECTIONS_ITEMS = 'selectionItems'

export const PROGRAM_COLLECTIONS_ITEMS = 'collectionsItems'

export const PROGRAM_PERFORMANCES = 'performances'

export const PROGRAM_HIGHLIGHTS = 'highlightsItems'

export const PROGRAM_ADS_ITEMS = 'adsItems'

export const PROGRAM_ADVERTISEMENTS_ITEMS = 'advertisementsItems'
export const PROGRAM_ADVERTISEMENTS_ORDER = 'advertisementsOrder'

export const PROGRAM_WEISCHERAD_ITEMS = 'weischerAdItems'

export const PROGRAM_ATTRIBUTES = 'attributes'
export const PROGRAM_ATTRIBUTES_GLOBAL = 'globalAttributes'

export const PROGRAM_MOVIEMAPPING_ITEMS = 'movieMappingsItems'

export const PROGRAM_MOVIEEXTENSIONS_ITEMS = 'movieExtensionsItems'
export const PROGRAM_MOVIEEXTENSIONS_ITEMS_TO_RESET = 'movieExtensionsItemsToReset'

export const UI_GENERAL = 'uiGeneral'
export const UI_PROGRAM = 'uiProgram'
export const UI_OVERLAY = 'uiOverlay'

export const FEATURES = 'wpFeatures'
export const THEME = 'wpTheme'
export const LOGO ="wpLogo"
export const SOCIALMEDIA = "wpSocialMedia"
export const FRONT = "wpFront"

export const MULTISITE_SELECTOR_STATUS = 'multisiteSelectorStatus'
export const MULTISITE_SELECTOR_ERROR = 'multisiteSelectorError'
export const MULTISITE_SELECTOR_EDITED = 'multisiteSelectorEdited'
export const MULTISITE_SELECTOR_ITEMS = 'multisiteSelectorItems'
export const MULTISITE_SELECTOR_ORDER = "multisiteSelectorOrder"

export const NEWSLETTER_DEFAULT = {
    status: requestStatus.INITIALIZED,
    error: {},
    campaigns: []
}

export const CLI_MULTICINEMA_MODE = 'cliMulticinemaMode'
export const CLI_CURRENT_CINEMA_ID = 'cliCurrentCinemaId'
export const CLI_CINEMA_CLIENT_ID = 'cliCinemaClientId'

export const FLYER_DATA = 'flyerData'
export const FLYER_DATA_CURRENT_WEEK = "flyerDataCurrentWeek"

export const PUSH_DATA = 'pushData'
export const PUSH_CREATE_WEEKS = "pushCreateWeeks"
export const PUSH_CREATE_CURRENT_WEEK = "pushCreateCurrentWeek"
export const PUSH_CREATE_STATUS = "pushCreateStatus"
export const PUSH_CREATE_DATA = "pushCreate"
export const PUSH_CREATE_FORM = "pushCreateForm"
export const PUSH_CREATE_ATTACHED_ITEM = "pushCreateAttachedItem"

export const NEWSPAPER_DATA = 'newspaperData'

export const WEEK_PROGRAM_FLYER_DATA = "weekProgramFlyerData"
export const WEEK_PROGRAM_FLYER_DATA_CURRENT_WEEK = "weekProgramFlyerDataCurrentWeek"
export const WEEK_PROGRAM_FLYER_DATA_DATE_SETTIGNS = "weekProgramFlyerDataDateSettings"

export const PRINT_WEEKS = "printWeeks"
export const PRINT_TYPES_DATA = "printTypesData"

export const EVENT_DATA_EVENTS = "eventDataEvents"
export const EVENT_DATA_SETTINGS = "eventDataSettings"


export const DATA_KEY_PATHS = {
    [AUTH_STATUS]:                      [AUTH, 'status'],
    [AUTH_ERROR]:                       [AUTH, 'error'],
    [AUTH_CAPS]:                        [AUTH, 'caps'],
    [LOAD_ALL_STATUS]:                  [LOAD_ALL, 'status'],
    [LOAD_ALL_LOADED]:                  [LOAD_ALL, 'loaded'],
    [LOAD_ALL_ERROR]:                   [LOAD_ALL, 'error'],
    [PROGRAM_STATUS]:                   [PROGRAM, 'status'],
    [PROGRAM_ERROR]:                    [PROGRAM, 'error'],
    [PROGRAM_PY_MOVIES_ITEMS]:          [PROGRAM, 'pyMovies', 'items'],
    [PROGRAM_KH_MOVIES_ITEMS]:          [PROGRAM, 'khMovies', 'items'],
    [PROGRAM_COMP_MOVIES_ITEMS]:        [PROGRAM, 'compesoMovies', 'items'],
    [PROGRAM_PM_MOVIES_ITEMS]:          [PROGRAM, 'pmMovies', 'items'],
    [PROGRAM_DIESEL_MOVIES_ITEMS]:      [PROGRAM, 'dieselv2Movies', 'items'],
    [PROGRAM_CORTEC_MOVIES_ITEMS]:      [PROGRAM, 'cortecMovies', 'items'],
    [PROGRAM_CLI_MOVIES_ITEMS]:         [PROGRAM, 'cliMovies', 'items'],
    [PROGRAM_CLI_MOVIES_ORDER]:         [PROGRAM, 'cliMovies', 'order'],
    [PROGRAM_META_MOVIES_ITEMS]:        [PROGRAM, 'metaMovies', 'items'],
    [PROGRAM_PERFORMANCES]:             [PROGRAM, 'performances', 'items'],
    [PROGRAM_SELECTIONSDISPLAY_ITEMS]:  [PROGRAM, 'itemSelectionsDisplay', 'items'],
    [PROGRAM_SELECTIONSDISPLAY_ORDER]:  [PROGRAM, 'itemSelectionsDisplay', 'order'],
    [PROGRAM_SELECTIONS_ITEMS]:         [PROGRAM, 'itemSelections', 'items'],
    [PROGRAM_COLLECTIONS_ITEMS]:        [PROGRAM, 'itemCollections', 'items'],
    [PROGRAM_HIGHLIGHTS]:               [PROGRAM, 'highlights', 'items'],
    [PROGRAM_ADS_ITEMS]:                [PROGRAM, 'ads', 'items'],
    [PROGRAM_ADVERTISEMENTS_ITEMS]:     [PROGRAM, 'advertisements', 'items'],
    [PROGRAM_ADVERTISEMENTS_ORDER]:     [PROGRAM, 'advertisements', 'order'],
    [PROGRAM_WEISCHERAD_ITEMS]:         [PROGRAM, 'weischerAds', 'items'],
    [PROGRAM_MOVIEMAPPING_ITEMS]:       [PROGRAM, 'movieMappings', 'items'],
    [PROGRAM_MOVIEEXTENSIONS_ITEMS]:    [PROGRAM, 'movieExtensions', 'items'],
    [PROGRAM_MOVIEEXTENSIONS_ITEMS_TO_RESET]: [PROGRAM, 'movieExtensions', 'itemsToReset'],
    [PROGRAM_CINEMAS]:                  [PROGRAM, 'cinemas', 'items'],
    
    [PROGRAM_ATTRIBUTES]:                   [PROGRAM, 'attributes'],
    [PROGRAM_ATTRIBUTES_GLOBAL]:            [PROGRAM, 'attributes', 'global'],

    [FLYER_DATA]:                           [PRINTDATA, 'flyer'],
    [FLYER_DATA_CURRENT_WEEK]:              [PRINTDATA, 'flyer', 'currentWeek'],

    [PUSH_CREATE_WEEKS]:                    [PUSHDATA, 'create', 'weeks'],
    [PUSH_CREATE_CURRENT_WEEK]:             [PUSHDATA, 'create', 'currentWeek'],    
    [PUSH_CREATE_DATA]:                     [PUSHDATA, 'create'],    
    [PUSH_CREATE_FORM]:                     [PUSHDATA, 'create', 'form'],    
    [PUSH_CREATE_STATUS]:                   [PUSHDATA, 'create', 'status'],    
    [PUSH_CREATE_ATTACHED_ITEM]:            [PUSHDATA, 'create', 'attachedItem'],    
    
    [NEWSPAPER_DATA]:                       [PRINTDATA, 'newspaper'],

    [WEEK_PROGRAM_FLYER_DATA]:              [PRINTDATA, 'weekProgramFlyer'],
    [WEEK_PROGRAM_FLYER_DATA_CURRENT_WEEK]: [PRINTDATA, 'weekProgramFlyer', 'currentWeek'],
    [WEEK_PROGRAM_FLYER_DATA_DATE_SETTIGNS]:[PRINTDATA, 'weekProgramFlyer', 'dateSettings'],

    [PRINT_WEEKS]:                          [PRINTDATA, 'weeks'],
    [PRINT_TYPES_DATA]:                     [PRINTDATA, 'printTypes'],

    [SIGNAGE_DATA]:                         [SIGNAGE_DATA],
    
    [ROUTES_DATA]:                          [ROUTES_DATA],
    
    [UI_GENERAL]:                           [UI, 'general'],
    [UI_PROGRAM]:                           [UI, 'program'],
    [UI_OVERLAY]:                           [UI, 'overlay'],

    [CLI]:                                  [CLI],
    [CLI_MULTICINEMA_MODE]:                 [CLI, 'multiCinemaMode'],
    [CLI_CURRENT_CINEMA_ID]:                [CLI, 'currentCinemaId'],
    [CLI_CINEMA_CLIENT_ID]:                 [CLI, 'cinemaClientId'],

    [MULTISITE_SELECTOR_STATUS]:            [MULTISITE_SELECTOR, 'status'],
    [MULTISITE_SELECTOR_ERROR]:             [MULTISITE_SELECTOR, 'error'],
    [MULTISITE_SELECTOR_EDITED]:            [MULTISITE_SELECTOR, 'selector', 'edited'],
    [MULTISITE_SELECTOR_ITEMS]:             [MULTISITE_SELECTOR, 'selector', 'items'],
    [MULTISITE_SELECTOR_ORDER]:             [MULTISITE_SELECTOR, 'selector', 'order'],

    [EVENT_DATA]:                           [EVENT_DATA],
    [EVENT_DATA_EVENTS]:                    [EVENT_DATA, 'events', 'data'],
    [EVENT_DATA_SETTINGS]:                  [EVENT_DATA, 'settings', 'data'],
    
    [FEATURES]:                             [WPSERVER, 'data', 'data', 'features'],
    [FRONT]:                                [WPSERVER, 'data', 'data', 'front'],
    [THEME]:                                [WPSERVER, 'data', 'data', 'theme'],
    [LOGO]:                                 [WPSERVER, 'data', 'data', 'logo'],
    [SOCIALMEDIA]:                          [WPSERVER, 'data', 'data', 'socialmedia'],

    [TRANSLATION]:                          [TRANSLATION]
}
